import { createUseStyles } from "react-jss";
import {colors} from "../../constants/colors";

const styles = createUseStyles({
  notificationContainer: {
    display: "flex",
    gap: "16px",
    justifyContent: "space-between"
  },
  title:{
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.grey,
  },
  description:{
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.mediumGrey,
  }
});

export default styles;
